<template>
  <div class="py-2 px-3">
    <h5 class="grey--text">
      {{ $t('appointment.label.observations') }}
    </h5>
    <p class="text-body-2 mb-0">
      {{ observations }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BoardCardObservationContent',

  props: {
    observations: {
      type: String,
    },
  },
}
</script>
